import type { WorkerCommand } from './program.ts';
export class WorkerRunner { constructor(_deliver: (action: string, id: string, body: string, code: string, message: string) => void) {} validate(_commands: ReadonlyArray<WorkerCommand>): void {} run(_commands: ReadonlyArray<WorkerCommand>): void {} close(): void {} }
